import { useTenant } from "@/providers/session";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import { noop } from "lodash";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

export const useDeleteEmailForwarding = () => {
  const { t } = useTranslation();
  const { tenantId } = useTenant();
  const [deleteEmailForwarding, { data, loading, error }] = useMutation(
    DELETE_EMAIL_FORWARDING_MUTATION,
    {
      optimisticResponse: {
        deleteEmailForwarding: true,
      },
      update: (cache, { data: { deleteEmailForwarding } }, { variables }) => {
        if (deleteEmailForwarding) {
          const { emailForwardingId } = variables as any;

          cache.modify({
            fields: {
              emailForwardings(existingEmailForwardings = []) {
                return existingEmailForwardings.filter(
                  (forwarding: any) =>
                    forwarding.emailForwardingId !== emailForwardingId,
                );
              },
            },
          });
        }
      },
    },
  );

  const handleDeleteEmailForwarding = async (
    emailForwardingId: string,
    onSuccess: () => void = noop,
    onError: () => void = noop,
  ) => {
    if (!tenantId) {
      throw new Error("Tenant ID is required");
    }

    toast.promise(
      deleteEmailForwarding({
        variables: {
          tenantId,
          emailForwardingId,
        },
      }),
      {
        loading: t("generic_loading"),
        success: () => {
          onSuccess();
          return t("generic_success");
        },
        error: () => {
          onError();
          return t("generic_error", { richColors: true });
        },
      },
    );
  };

  return {
    deleteEmailForwarding: handleDeleteEmailForwarding,
    data: data?.deleteEmailForwarding,
    loading,
    error,
  };
};

export const DELETE_EMAIL_FORWARDING_MUTATION = gql`
  mutation DeleteEmailForwarding(
    $tenantId: String!
    $emailForwardingId: String!
  ) {
    deleteEmailForwarding(
      tenantId: $tenantId
      emailForwardingId: $emailForwardingId
    )
  }
`;
